/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_DriftInputs */

const en_landing_nav_drift = /** @type {(inputs: Landing_Nav_DriftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drift-free editing`)
};

const zh_landing_nav_drift = /** @type {(inputs: Landing_Nav_DriftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无漂移编辑`)
};

/**
* | output |
* | --- |
* | "Drift-free editing" |
*
* @param {Landing_Nav_DriftInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_nav_drift = /** @type {((inputs?: Landing_Nav_DriftInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_DriftInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_nav_drift(inputs)
	return zh_landing_nav_drift(inputs)
});
export { landing_nav_drift as "landing.nav.drift" }